export default {
  amapAdd: 'https://tsapi.amap.com/v1/track/service/add', // 高德添加服务
  addTerminal: 'https://tsapi.amap.com/v1/track/terminal/add', // 高德添加终端
  addTrace: 'https://tsapi.amap.com/v1/track/trace/add', // 高德添加轨迹
  uploadPoint: 'https://tsapi.amap.com/v1/track/point/upload', // 高德添加轨迹点
  getLastpoint: 'https://tsapi.amap.com/v1/track/terminal/lastpoint', // 高德添加轨迹点
  getAmapList: 'https://tsapi.amap.com/v1/track/service/list', // 高德获取服务列表
  selectDriverPositionById: 'driverposition/selectDriverPositionById', // 查询地址信息
  selectOrderPositionlist: '/driverposition/selectOrderPositionlist', // 查询地址信息
  getOrderList: '/weixin/orderList', // 获取订单列表
  getOrderInfo: '/weixin/orderInfo', // 订单详情查询
  getTerminalVersionInfo: '/weixin/getTerminalVersionInfo', // 根据id获取版本
  getTerminalVersionListByGroup: '/weixin/getTerminalVersionListByGroup', // 跟剧组获取版本
  login: '/invoker/login', // 登陆
  register: '/invoker/register', // 共享链接客户注册
  customerActRegister: '/invoker/customerActRegister', // 共享链接客户注册
  activityregister: '/invoker/activityregister', // 共享链接司机注册
  driverActRegister: '/invoker/driverActRegister', // 共享链接司机注册
  getCustomerRecommendRankingList: '/weixin/getCustomerRecommendRankingList', // 客户向客户推荐的排行榜
  getDriverRecommendRankingList: '/weixin/getDriverRecommendRankingList', // 司机向司机推荐的排行榜
  selectActDriverRe: '/weixin/selectActDriverRe', // 查询司机推荐信息
  selectActCustomerRe: '/weixin/selectActCustomerRe', // 查询客户推荐信息
  getSignature: '/weixin/getSignature', // 获取签名
  unOrder: '/weixin/pay/unOrder', // 公众号支付
  findPayOrder: '/weixin/findPayOrder', // 待支付代付订单
  empRecomCustomer: '/invoker/empRecomCustomer', // 员工邀请客户
  empRecomDriver: '/wxdriver/empRecomDriver', // 员工邀请司机
  h5PageQuery: '/pageQuery/h5PageQuery', // H5页面价格查询
  getGaoDeDriving: 'https://restapi.amap.com/v3/direction/driving', // 获取高德路径规划
  sendSms: '/sms/sendSms', // 短信验证码
  getAllInsureConfigList: '/iInsure/allInsureConfigList', // 获取保费数据
  friendscircle: '/friendscircle/fc' // 微信朋友圈
}



// WEBPACK FOOTER //
// ./src/api/serverUrl.js